import { render } from "./KeeperYear2.vue?vue&type=template&id=9b45b470"
import script from "./KeeperYear2.vue?vue&type=script&lang=js"
export * from "./KeeperYear2.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__